import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CaretRight, ClipboardText, Cake } from "@phosphor-icons/react";

function age(dob) {
  if (!dob) return "";
  const d = new Date(dob);
  return Math.floor((Date.now() - d.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
}

export default function CoachDashboard() {
  const nav = useNavigate();
  const [players, setPlayers] = useState(null);
  const [term, setTerm] = useState(null);

  useEffect(() => {
    api.get("/players").then((r) => setPlayers(r.data));
    api.get("/terms/current").then((r) => setTerm(r.data));
  }, []);

  return (
    <div className="space-y-5" data-testid="coach-dashboard">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="font-label">Your roster</div>
          <h1 className="font-heading uppercase text-3xl sm:text-4xl tracking-tight">Players</h1>
          {term && (
            <div className="mt-2">
              <span className="px-2.5 py-1 bg-[#dfff00] text-black rounded-md text-xs font-bold uppercase tracking-wider" data-testid="current-term-pill">
                {term.label}
              </span>
              <span className="text-xs text-zinc-500 ml-2">— current term for evaluations</span>
            </div>
          )}
        </div>
        {players && (
          <div className="text-right">
            <div className="font-heading text-3xl text-[#dfff00] leading-none">{players.length}</div>
            <div className="font-label mt-1">assigned</div>
          </div>
        )}
      </div>

      {!players && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {[...Array(4)].map((_, i) => <div key={i} className="skeleton h-20" />)}
        </div>
      )}
      {players?.length === 0 && (
        <div className="surface p-8 text-center text-zinc-400">No players assigned to you yet.</div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="player-list">
        {players?.map((p) => (
          <div
            key={p.id}
            className="surface p-4 flex items-center justify-between hover:border-[#dfff00]/40 transition-colors cursor-pointer"
            onClick={() => nav(`/players/${p.id}`)}
            data-testid={`player-card-${p.id}`}
          >
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-12 h-12 rounded-md bg-[#1a1a1a] border border-[#27272a] flex items-center justify-center font-heading text-xl shrink-0">
                {p.name.split(" ").map((s) => s[0]).slice(0, 2).join("")}
              </div>
              <div className="min-w-0">
                <div className="font-semibold truncate">{p.name}</div>
                <div className="text-xs text-zinc-500 flex items-center gap-1 mt-0.5">
                  <Cake size={12} weight="bold" /> {age(p.date_of_birth)} yrs
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <Link
                to={`/players/${p.id}/evaluate`}
                onClick={(e) => e.stopPropagation()}
                className="px-3 h-10 inline-flex items-center justify-center bg-[#dfff00] text-black rounded-md font-bold text-xs uppercase tracking-wider hover:bg-[#e5ff33] gap-1"
                data-testid={`evaluate-btn-${p.id}`}
              >
                <ClipboardText size={14} weight="bold" /> Evaluate
              </Link>
              <CaretRight size={20} className="text-zinc-600" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
